// Messages browsers use for a fetch that never got a response: Chrome, Safari and Firefox.
const NETWORK_ERROR_MESSAGE = /^(Failed to fetch|Load failed|NetworkError)/;

/**
 * Whether the error is a browser-level fetch failure (offline, blocked, navigated away) or a
 * cancelled request. Neither says anything about our API, so callers don't report them.
 */
export function isNetworkError(error: unknown): boolean {
	if (error instanceof Error && error.name === 'AbortError') return true;
	return error instanceof TypeError && NETWORK_ERROR_MESSAGE.test(error.message);
}
